import React from 'react';
import {
  PAYMENT_DIRECTION_DEPOSIT,
  PAYMENT_DIRECTION_WITHDRAWAL,
} from './paymentDirection';


const PaymentDirectionSelector = ({ value, onChange }) => (
  <div>
    <span className="mb-2 block text-xs font-medium text-gray-700 sm:text-sm">
      Buchungsart
    </span>
    <div className="grid grid-cols-2 gap-2 rounded-lg bg-gray-100 p-1">
      <button
        type="button"
        onClick={() => onChange(PAYMENT_DIRECTION_DEPOSIT)}
        aria-pressed={value === PAYMENT_DIRECTION_DEPOSIT}
        className={`rounded-md px-3 py-2 text-sm font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-emerald-500 ${
          value === PAYMENT_DIRECTION_DEPOSIT
            ? 'bg-emerald-600 text-white shadow-sm'
            : 'bg-white text-gray-700 hover:bg-emerald-50'
        }`}
        data-testid="payment-direction-deposit"
      >
        Einzahlung (+)
      </button>
      <button
        type="button"
        onClick={() => onChange(PAYMENT_DIRECTION_WITHDRAWAL)}
        aria-pressed={value === PAYMENT_DIRECTION_WITHDRAWAL}
        className={`rounded-md px-3 py-2 text-sm font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-rose-500 ${
          value === PAYMENT_DIRECTION_WITHDRAWAL
            ? 'bg-rose-600 text-white shadow-sm'
            : 'bg-white text-gray-700 hover:bg-rose-50'
        }`}
        data-testid="payment-direction-withdrawal"
      >
        Auszahlung (−)
      </button>
    </div>
  </div>
);


export default PaymentDirectionSelector;
